/**
 * Converts an error of unknown type to a readable string representation
 * @param error - The error to convert (could be Error, string, or any object)
 * @returns A string representation of the error
 */
export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message
  }
  if (typeof error === 'string') {
    return error
  }
  if (error === null || error === undefined) {
    return 'An unknown error occurred'
  }
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as Record<string, unknown>).message
    if (typeof message === 'string') {
      return message
    }
    if (message instanceof Error) {
      return message.message
    }
    try {
      return JSON.stringify(message)
    } catch {
      return 'An unknown error occurred'
    }
  }
  try {
    return JSON.stringify(error)
  } catch {
    return 'An unknown error occurred'
  }
}
